var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Google Calendar",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 32,
    rx: "15%",
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 340h74V174H340v-74H137Q100 100 100 135",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338 100v76h74v-41q0-35-35-35",
    fill: "#1967d2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338 174h74V338h-74",
    fill: "#fbbc04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 338v39q0 35 35 35h41v-74",
    fill: "#188038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174 338H338v74H174",
    fill: "#34a853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M338 412v-74h74",
    fill: "#ea4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308",
    stroke: "#4285f4",
    strokeWidth: 15,
    strokeLinejoin: "bevel",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCal);
export default __webpack_public_path__ + "static/media/GoogleCal.1740e8b8233220c92ed3dc098760f63c.svg";
export { ForwardRef as ReactComponent };